// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfiesTip_style_wrapper__Ziy15","rotate":"SelfiesTip_style_rotate__9ugkL"};